import { render, staticRenderFns } from "./layoutHeader.vue?vue&type=template&id=40f5676f&scoped=true"
import script from "./layoutHeader.vue?vue&type=script&lang=js"
export * from "./layoutHeader.vue?vue&type=script&lang=js"
import style0 from "./layoutHeader.vue?vue&type=style&index=0&id=40f5676f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f5676f",
  null
  
)

export default component.exports